import { render, staticRenderFns } from "./36.vue?vue&type=template&id=17882841&scoped=true&"
var script = {}
import style0 from "./36.vue?vue&type=style&index=0&id=17882841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17882841",
  null
  
)

export default component.exports